import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExquisiteSurfaceArtistry() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="37355" id="being-there" ref={sectionRef} className="relative w-full bg-[#04052F] py-20 overflow-hidden dark">
      {}
      <div className="absolute inset-0 bg-linear-to-br from-[#04052F] to-[#090834]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(94,66,195,0.05)_0%,transparent_70%)]" />

      <div className="relative z-10 max-w-7xl mx-auto px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          
          {}
          <div className={`
              w-full lg:w-[50%] 
              transition-all duration-1000 ease-out
              ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}
            `}>
            <div className="flex flex-col gap-4">
              <h1 className="text-5xl md:text-6xl lg:text-6xl font-bold tracking-tighter text-white drop-shadow-xl">
                Being There
              </h1>
              
              <div className="space-y-6 text-white leading-relaxed">
                <p className="font-medium text-lg md:text-xl">The Caregiving Workforce Platform that Puts People First.</p>
              </div>

              <div className="pt-4">
                <Button asChild size="lg" className="w-full sm:w-auto h-auto bg-gradient-to-r from-[#5E42C3] to-[#2EA3D2] border-none text-white hover:opacity-90 hover:scale-[1.02] transition-all duration-300 rounded-full px-10 py-7 text-lg font-semibold shadow-lg shadow-[#5E42C3]/20">
                  <Link to="/HomePage">
                    Learn more
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          {}
          <div className={`
              w-full lg:w-[50%]
              transition-all duration-1000 delay-300 ease-out
              ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}
            `}>
            <div className="relative group">
              <div className="relative rounded-xl shadow-2xl overflow-hidden bg-[#090834]">
                 <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572459/img/image_uswhudk2.webp" alt="Caregiving workforce professionals collaborating in a modern office environment" className="w-full h-full object-contain aspect-[4/5] lg:aspect-square" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-[#04052F]/40 to-transparent pointer-events-none" />
              </div>
              
              {}
              <div className="absolute -inset-4 bg-white/5 blur-2xl -z-10 rounded-full opacity-50" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}